import { ArticleProps } from "../../../../../redux/slices/article/Article";
import { VideoPlayer } from "../../../../Common";
import { useFindContent } from "../../useFindContent";
import PreviewLayout from "../PreviewLayout";
import VideoProps from "./Video";

const VideoPreview = ({
  id,
  setIsVideoCreated,
  onDeleteVideo,
}: VideoProps.VideoPreviewProps) => {
  const { content_data, content_id } = useFindContent(
    id
  ) as ArticleProps.WithVideoContent;
  const { title, description, duration } = content_data;

  return (
    <PreviewLayout
      onDelete={onDeleteVideo}
      onEdit={() => setIsVideoCreated(false)}
      width="100%"
    >
      <VideoPlayer
        video_id={content_id}
        video_title={title}
        video_description={description}
        duration={duration}
        isViewOnly={true}
      />
    </PreviewLayout>
  );
};

export default VideoPreview;
